/* eslint-disable */
import React, { useState, useEffect } from "react";
import axios from "axios";
import TableOne from "../Table/TableOne"; // Import your table component
import Modal from "react-modal";
import "./../style/common.css";
import "../login/Login.css";
import {
  TextField,
  MenuItem,
  Radio,
  RadioGroup,
  FormHelperText,
  IconButton,
} from "@mui/material";
import {
  FaUserTie,
  FaUser,
  FaAddressCard,
  FaCity,
  FaSearch,
  FaEyeSlash,
  FaEye,
} from "react-icons/fa";
import { MdEmail, MdBadge } from "react-icons/md";
import { TbMapPinCode } from "react-icons/tb";
import { RiLockPasswordFill } from "react-icons/ri";
import { SlOrganization } from "react-icons/sl";
import { FaMobileRetro, FaTreeCity } from "react-icons/fa6";
import { InputAdornment } from "@mui/material";
import { GiWorld } from "react-icons/gi";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CiWarning } from "react-icons/ci";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import emailjs from "emailjs-com";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";


// Premium Vibrant Status Colors: Pending (Red), Ongoing (Orange), InReview (Blue), Completed (Green), Deadline (Crimson)
const COLORS = ["#ff4d4d", "#ffa500", "#3b82f6", "#2ecc71", "#c0392b"];


const Employee = () => {
  const [password, setPassword] = useState("");
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [department, setDepartment] = useState([]);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [errors, setErrors] = useState({}); //error show state
  const [filteredEmployee, setFilteredEmployee] = useState([]); // For search functionality
  const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] =
    useState(false);
  const [resetPasswordData, setResetPasswordData] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [showDeleteEmployeeBox, setShowDeleteEmployeeBox] = useState(false);
  const [deleteEmployeeName, setDeleteEmployeeName] = useState("");
  const [deleteEmployeeId, setDeleteEmployeeId] = useState(null);
  const [employeeProfile, setEmployeeProfile] = useState(
    "../images/imageicon.png"
  ); // State to store profile image
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [selectedEmployeeName, setSelectedEmployeeName] = useState("");
  const [addressDialogOpen, setAddressDialogOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const userRole = localStorage.getItem("role"); // Get user role from local storage
  const userId = JSON.parse(localStorage.getItem("user"))?.id; // Fetch userId from local storage
  const [isDashboardModalOpen, setIsDashboardModalOpen] = useState(false);
  const [openDashboardModalData, setDashboardOpenModalData] = useState(null);


  const [formData, setFormData] = useState({
    employee_first_name: "",
    employee_middle_name: "",
    employee_last_name: "",
    employee_email: "",
    employee_password: "",
    employee_gender: "",
    employee_contact: "",
    employee_dept_id: "",
    employee_type: "",
    employee_dateofjoin: "",
    employee_country: "",
    employee_state: "",
    employee_city: "",
    employee_address: "",
    employee_pincode: "",
    employee_profile: "",
    employee_role: "",
    employee_islastlogin: "",
    employee_dateofleave: "",
    employee_isactive: false,
    employee_attachfile: "",
  });
  const [editMode, setEditMode] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");
  const userData = JSON.parse(localStorage.getItem("user"));


  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  // Fetch Department data from the API
  const fetchDepartment = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "/api/dept"
      );
      const deptData = response.data.department.map((dept) => ({
        DepartmentId: dept.department_id,
        DepartmentName: dept.department_name,
        DepartmentIsActive: dept.department_isactive,
      }));
      console.log("department-->", deptData.DepartmentName);
      setDepartment(deptData);
    } catch (error) {
      console.error("Error fetching department data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchDepartment();
  }, []);


  // Fetch all Indian cities from the API
  const fetchIndianCities = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/api/indian-cities");
      const cityData = response.data.data.map((c) => ({
        CityId: c.id,
        CityName: c.name,
      }));
      setCity(cityData);
    } catch (error) {
      console.error("Error fetching Indian cities:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchIndianCities();
  }, []);


  // Fetch employee data from the API
  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "/api/emp"
      );
      console.log(response);
      const employeeData = response.data.employees
        .filter(
          (emp) =>
            emp.employee_role === "E" ||
            emp.employee_role === "T" ||
            emp.employee_role == "M"
        )
        .map((emp) => ({
          Employee_id: emp.employee_id,
          DeptName: emp.department?.department_name || "N/A", // Extract department name
          Country: emp.employee_country,
          State: emp.employee_state,
          City: emp.employee_city,
          FirstName: emp.employee_first_name,
          MiddleName: emp.employee_middle_name,
          LastName: emp.employee_last_name,
          Email: emp.employee_email,
          IsLastLogin: emp.employee_islastlogin,
          Address: emp.employee_address,
          Pincode: emp.employee_pincode,
          DateofJoin: emp.employee_dateofjoin,
          DateofLeave: emp.employee_dateofleave,
          IsActive: emp.employee_isactive,
          Gender: emp.employee_gender,
          Contact: emp.employee_contact,
          Profile: emp.employee_profile || "../images/imageicon.png", // Default image callback
          File: emp.employee_attachfile,
          Role: emp.employee_role,
          EmpType: emp.employee_type,
        }));
      if (employeeData.length > 0) {
        setEmployeeProfile(employeeData[0].Profile); // Set first admin's profile as default
      }
      console.log("Filtered employees:", employeeData);
      setEmployees(employeeData);
      setFilteredEmployee(employeeData);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchEmployees();
  }, []);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const openModal = (employee = null) => {
    if (employee) {
      setFormData(employee);
      // setEditMode(true);
    } else {
      setFormData({
        employee_first_name: "",
        employee_middle_name: "",
        employee_last_name: "",
        employee_email: "",
        employee_password: "",
        employee_contact: "",
        employee_address: "",
        employee_pincode: "",
        employee_gender: "male",
        employee_country: "",
        employee_state: "",
        employee_city: "",
        employee_dept_id: "",
        employee_islastlogin: "",
        employee_dateofjoin: "",
        employee_dateofleave: "",
        employee_isactive: true,
        employee_profile: "",
        employee_attachfile: "",
        employee_role: "",
        employee_type: "",
        Employee_id: "",
      });
      setEditMode(false);
    }
    setErrors({}); // Reset validation errors
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };


  //code for delete Employee
  const handleDelete = async (emp) => {
    const employee_id = emp.Employee_id;
    const employee_fullName = `${emp.FirstName || ""} ${emp.MiddleName || ""} ${emp.LastName || ""
      }`
      .trim()
      .replace(/\s+/g, " ");
    if (!employee_id) {
      toast.error("Invalid Employee ID. Please try again.");
      return;
    }
    // Set the employee full name and ID before showing the confirmation box
    setDeleteEmployeeName(employee_fullName);
    setDeleteEmployeeId(employee_id);
    setShowDeleteEmployeeBox(true); // Show the custom confirmation box
  };


  const confirmDeleteEmployee = async () => {
    if (!deleteEmployeeId) return;
    try {
      const response = await axios.delete(
        `/api/emp/delete/${deleteEmployeeId}`
      );
      if (response.status === 200) {
        toast.success("Employee deleted successfully!");
        const updatedEmployees = employees.filter(
          (item) => item.Employee_id !== deleteEmployeeId
        );
        setEmployees(updatedEmployees);
        setFilteredEmployee(updatedEmployees);
      }
      setShowDeleteEmployeeBox(false); // Close the confirmation box
    } catch (error) {
      console.error("Error deleting Employee:", error);
      toast.error("An error occurred while deleting the Employee.");
      setShowDeleteEmployeeBox(false); // Close the box on error
    }
  };


  const cancelDeleteEmployee = () => {
    setShowDeleteEmployeeBox(false); // Close the box
  };


  //confirmation for image
  const handleImageSelection = (
    Employee_id,
    FirstName,
    MiddleName,
    LastName,
    img
  ) => {
    if (!img) {
      toast.error("Please select an image.");
      return;
    }
    const fullName = `${FirstName} ${MiddleName} ${LastName}`.trim();
    console.log("Selected Employee:", fullName); // Debugging
    setSelectedImage(img);
    setSelectedEmployeeId(Employee_id);
    setSelectedEmployeeName(fullName);
    setIsUploadModalOpen(true); // Open confirmation modal
  };
  const confirmImageUpload = async () => {
    if (!selectedImage || !selectedEmployeeId) return;
    const formData = new FormData();
    formData.append("employee_image", selectedImage);
    setIsUploadModalOpen(false);
    setLoading(true);
    try {
      const response = await axios.post(
        `/api/emp/add-image/${selectedEmployeeId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Image uploaded successfully!");
        fetchEmployees(); // Refresh employee data after upload
      } else {
        toast.error("Failed to upload image.");
      }
    } catch (error) {
      console.error("Image upload error:", error);
      toast.error("An error occurred while uploading the image.");
    }
    setIsUploadModalOpen(false); // Close the confirmation modal
    setSelectedImage(null);
    setSelectedEmployeeId(null);
    setSelectedEmployeeName("");
  };


  const cancelImageUpload = () => {
    setIsUploadModalOpen(false);
    setSelectedImage(null);
    setSelectedEmployeeId(null);
    setSelectedEmployeeName("");
  };


  const handleEdit = (employee) => {
    console.log("employee-->", employee);
    setFormData({
      employee_role: employee.Role,
      Employee_id: employee.Employee_id,
      employee_first_name: employee.FirstName || "",
      employee_middle_name: employee.MiddleName || "",
      employee_last_name: employee.LastName || "",
      employee_email: employee.Email || "",
      employee_contact: employee.Contact || "",
      employee_address: employee.Address || "",
      employee_pincode: employee.Pincode || "",
      employee_gender: employee.Gender || "",
      employee_country:
        country.find((c) => c.CountryName === employee.Country)?.CountryId ||
        "",
      employee_state:
        state.find((s) => s.StateName === employee.State)?.StateId || "",
      employee_city:
        city.find((ct) => ct.CityName === employee.City)?.CityId || "",
      employee_dept_id:
        department.find((d) => d.DepartmentName === employee.DeptName)
          ?.DepartmentId || "",
      employee_dateofjoin: employee.DateofJoin || "",
      employee_dateofleave: employee.DateofLeave || "",
      employee_isactive: employee.IsActive || false,
      employee_type: employee.EmpType || "",
    });
    setEditMode(true); // Enable edit mode
    setIsModalOpen(true); // Open modal with pre-filled data
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validation Logic
    const validateForm = () => {
      const newErrors = {};
      if (!formData.employee_first_name) {
        newErrors.employee_first_name = "First name is required.";
      }
      if (!formData.employee_last_name) {
        newErrors.employee_last_name = "Last name is required.";
      }
      if (!formData.employee_email) {
        newErrors.employee_email = "Email is required.";
      } else if (!/\S+@\S+\.\S+/.test(formData.employee_email)) {
        newErrors.employee_email = "Please enter a valid email address.";
      }
      // Check for duplicate email
      const emailExists = employees.some(
        (emp) => emp.Email === formData.employee_email
      );
      if (emailExists && !editMode) {
        newErrors.employee_email = "Email already exists.";
        toast.error("Email already exists!");
      }
      if (!editMode && !formData.employee_password) {
        newErrors.employee_password = "Password is required.";
      } else if (!editMode && formData.employee_password.length < 6) {
        newErrors.employee_password = "Password must be at least 6 characters.";
      }
      if (!editMode && !formData.employee_confirm_password) {
        newErrors.employee_confirm_password = "Confirm Password is required.";
      } else if (
        !editMode &&
        formData.employee_confirm_password !== formData.employee_password
      ) {
        newErrors.employee_confirm_password =
          "Confirm Password must be same as Password";
      }
      if (!/^\d{10}$/.test(formData.employee_contact)) {
        newErrors.employee_contact = "Contact number must be 10 digits.";
      }
      if (!formData.employee_dept_id) {
        newErrors.employee_dept_id = "Please select a department.";
      }
      if (!formData.employee_role) {
        newErrors.employee_role = "Please select a Role.";
      }
      if (!formData.employee_type) {
        newErrors.employee_type = "employee type is required.";
      }
      if (formData.employee_pincode && !/^\d{6}$/.test(formData.employee_pincode)) {
        newErrors.employee_pincode = "Pincode must be 6 digits.";
      }
      return newErrors;
    };
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    try {
      const url = editMode
        ? `/api/emp/update/${formData.Employee_id}`
        : "/api/emp/add";


      const method = editMode ? "put" : "post";
      await axios({
        method,
        url,
        data: formData,
      });
      toast.success(
        editMode
          ? "Employee updated successfully!"
          : "Employee added successfully!"
      );
      if (!editMode) {
        sendEmail(
          formData.employee_email,
          formData.employee_first_name,
          formData.employee_password,
          "template_1pamk3l" // Replace with your EmailJS template ID for new employees
        );
      }
      fetchEmployees(); // Refresh the table
      closeModal();
    } catch (error) {
      console.error("Error submitting data:", error);
      toast.error(error.response?.data?.message || "An error occurred while saving the employee.");
    }
  };


  // Table columns
  const columns = [
    { Header: "Sr.No", accessor: (row, index) => index + 1, id: "index" },
    // {
    //   Header: "Profile",
    //   accessor: "Profile",
    //   Cell: ({ row }) => (
    //     <div>
    //       <label
    //         htmlFor={`file-upload-${row.original.Employee_id}`}
    //         style={{ cursor: "pointer" }}
    //       >
    //         <img
    //           src={row.original.Profile}
    //           alt="Profile"
    //           style={{
    //             width: "40px",
    //             height: "40px",
    //             borderRadius: "50%",
    //             objectFit: "cover",
    //           }}
    //         />
    //       </label>
    //       <input
    //         type="file"
    //         id={`file-upload-${row.original.Employee_id}`}
    //         style={{ display: "none" }}
    //         onChange={(e) =>
    //           handleImageSelection(
    //             row.original.Employee_id,
    //             row.original.FirstName,
    //             row.original.MiddleName,
    //             row.original.LastName,
    //             e.target.files[0]
    //           )
    //         }
    //       />
    //     </div>
    //   ),
    // },
    // {
    //   Header: "Name",
    //   accessor: (row) =>
    //     `${row.FirstName || ""} ${row.MiddleName || ""} ${
    //       row.LastName || ""
    //     }`.trim(),
    //   id: "FullName", // Provide a unique ID for the column
    //   className: "table-cell capitalize-text",
    // },
    {
      Header: "Profile",
      accessor: "Profile",
      Cell: ({ row }) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <label
            htmlFor={`file-upload-${row.original.Employee_id}`}
            style={{ cursor: "pointer" }}
          >
            <img
              src={row.original.Profile}
              alt={`${row.original.FirstName} ${row.original.LastName}`}
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </label>
          <span className="capitalize-text">
            {`${row.original.FirstName || ""} ${row.original.MiddleName || ""} ${row.original.LastName || ""
              }`.trim()}
          </span>
          <input
            type="file"
            id={`file-upload-${row.original.Employee_id}`}
            style={{ display: "none" }}
            onChange={(e) =>
              handleImageSelection(
                row.original.Employee_id,
                row.original.FirstName,
                row.original.MiddleName,
                row.original.LastName,
                e.target.files[0]
              )
            }
          />
        </div>
      ),
    },
    {
      Header: "Designation",
      accessor: "EmpType",
      className: "table-cell capitalize-text",
    },
    {
      Header: "Department",
      accessor: "DeptName",
      className: "table-cell capitalize-text",
    },
    {
      Header: "Role",
      accessor: "Role",
      Cell: ({ value }) => {
        // Mapping values to readable role names
        const roleMapping = {
          T: "Team Leader",
          E: "Employee",
          M: "Manager",
        };
        return roleMapping[value] || value; // Default to the value if not found in mapping
      },
      className: "table-cell capitalize-text",
    },
    {
      Header: "Email",
      accessor: "Email",
      className: "table-cell email-cell",
      Cell: ({ row }) => (
        <span className="email-cell">{row.original.Email.toLowerCase()}</span>
      ),
    },
    {
      Header: "Gender",
      accessor: "Gender",
      className: "table-cell capitalize-text",
    },
    { Header: "Contact", accessor: "Contact", className: "table-cell" },
    // {
    //   Header: "Address",
    //   accessor: "Address",
    //   className: "table-cell capitalize-text",
    //   Cell: ({ row }) => {
    //     const fullAddress = `${row.original.Address}, ${row.original.Pincode}`;
    //     const truncatedAddress =
    //       fullAddress.length > 15
    //         ? `${fullAddress.substring(0, 15)}...`
    //         : fullAddress;


    //     return (
    //       <>
    //         <span>{truncatedAddress}</span>
    //         {fullAddress.length > 15 && (
    //           <Button
    //             size="small"
    //             color="primary"
    //             onClick={() => {
    //               setSelectedAddress(fullAddress);
    //               setAddressDialogOpen(true);
    //             }}
    //           >
    //             See More
    //           </Button>
    //         )}
    //       </>
    //     );
    //   },
    // },
    // {
    //   Header: "City",
    //   accessor: "City",
    //   className: "table-cell capitalize-text",
    // },
    // {
    //   Header: "State",
    //   accessor: "State",
    //   className: "table-cell capitalize-text",
    // },
    // {
    //   Header: "Country",
    //   accessor: "Country",
    //   className: "table-cell capitalize-text",
    // },
    { Header: "DOJ", accessor: "DateofJoin", className: "table-cell" },

    { Header: "DOL", accessor: "DateofLeave", className: "table-cell" },
  ];


  //for upload image attachment in emp
  const handleImageUpload = async (Employee_id, img) => {
    if (!img) {
      toast.error("Please select a img.");
      return;
    }
    const formData = new FormData();
    formData.append("employee_image", img);
    try {
      const response = await axios.post(
        `/api/emp/add-image/${Employee_id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Image uploaded successfully!");
        fetchEmployees(); // Refresh tasks after upload
      } else {
        toast.error("Failed to upload image.");
      }
    } catch (error) {
      console.error("Image upload error:", error);
      toast.error("An error occurred while uploading the image.");
    }
  };


  // Open Reset Password Modal
  const openResetPasswordModal = (employee) => {
    setResetPasswordData(employee);
    setNewPassword("");
    setConfirmPassword("");
    setError("");
    setIsResetPasswordModalOpen(true);
  };


  // Close Reset Password Modal
  const closeResetPasswordModal = () => {
    setIsResetPasswordModalOpen(false);
    setResetPasswordData(null);
    setNewPassword("");
    setConfirmPassword("");
    setError("");
  };


  const handleResetPassword = async () => {
    if (!newPassword.trim() || !confirmPassword.trim()) {
      setError("Both fields are required.");
      return;
    }
    if (!newPassword || newPassword.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setError(""); // Clear errors if validation passes
    console.log("Password Reset successful!");
    try {
      const response = await axios.put(
        `/api/employee/reset-password/${resetPasswordData.Employee_id}`,
        { new_password: newPassword }
      );
      if (response.status === 200) {
        toast.success("Password reset successfully!");
        sendEmail(
          resetPasswordData.Email,
          resetPasswordData.FirstName,
          newPassword,
          "template_6x9pp0s" // Replace with your EmailJS template ID for password reset
        );
        closeResetPasswordModal();
      } else {
        toast.error("Failed to reset password. Try again.");
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      toast.error("An error occurred while resetting the password.");
    }
  };


  // Function to send an email using a dynamic template
  const sendEmail = (Email, FirstName, password, templateId) => {
    const emailParams = {
      user_email: Email,
      name: FirstName,
      message: `${password}`,
    };
    emailjs
      .send(
        "service_f5e1n5a", // Replace with your actual EmailJS Service ID
        templateId, // Pass different template IDs
        emailParams,
        "kJlfMgqOZEvNKqUpw" // Replace with your actual EmailJS Public Key
      )
      .then(() => {
        toast.success("Email sent successfully!");
      })
      .catch((emailError) => {
        console.error("Error sending email:", emailError);
        toast.error("Failed to send email.");
      });
  };


  const pieData = [
    {
      name: "Pending",
      value: openDashboardModalData?.taskStatusCounts?.pending || 0,
    },
    {
      name: "Ongoing",
      value: openDashboardModalData?.taskStatusCounts?.ongoing || 0,
    },
    {
      name: "InReview",
      value: openDashboardModalData?.taskStatusCounts?.inReview || 0,
    },
    {
      name: "Completed",
      value: openDashboardModalData?.taskStatusCounts?.completed || 0,
    },
    {
      name: "Deadline",
      value: openDashboardModalData?.taskStatusCounts?.deadline || 0,
    },
  ];


  // Open Reset Password Modal
  const openDashboardModal = (employee) => {
    setIsDashboardModalOpen(true);
    handleDashboard(employee);
  };


  // Close Reset Password Modal
  const closeDashboardModal = () => {
    setIsDashboardModalOpen(false);
    setDashboardOpenModalData(null);
  };


  const handleDashboard = async (employee) => {
    if (!employee || !employee.Employee_id) {
      console.error("Invalid employee object passed to dashboard", employee);
      return;
    }
    console.log("Dashboard clicked for-->");
    setLoading(true);
    setErrors(null);
    try {
      const response = await axios.get(
        `/api/dashboard/${employee.Employee_id}`
      );
      console.log("API Response:", response.data);
      if (response.status === 200 && response.data.total_tasks > 0) {
        console.log("Task Status Data:", response.data.task_status_counts);
        const taskStatusCounts = response.data.task_status_counts || {};


        const cleanedTaskStatusCounts = {
          pending: Number(taskStatusCounts.pending) || 0,
          ongoing: Number(taskStatusCounts.ongoing) || 0,
          inReview: Number(taskStatusCounts.inReview) || 0,
          completed: Number(taskStatusCounts.completed) || 0,
        };
        console.log("Cleaned Task Status Data:", cleanedTaskStatusCounts);
        setDashboardOpenModalData({
          taskStatusCounts: cleanedTaskStatusCounts,
          employeeName: `${employee.FirstName || ""} ${employee.LastName || ""
            }`,
        });
        setIsDashboardModalOpen(true);
      } else {
        throw new Error(response.data.message || "No tasks found.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrors(error.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      <ToastContainer />
      {loading}
      <div
        className="page-head"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "10px",
          marginLeft: "1%",
          marginRight: "2%",
        }}
      >
        <h1>
          <FaUserTie /> Employee
        </h1>
        <button className="add-button" onClick={() => openModal()}>
          + Add
        </button>
      </div>
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <TableOne
          columns={columns}
          data={filteredEmployee.slice().reverse()}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleResetPassword={openResetPasswordModal}
          isResetPassword={true === "manager" || "admin"}
          isDeleteAction={true === "manager" || "admin"}
          isEditAction={true === "manager" || "admin"}
        />
      )}


      {/* PieChart */}
      <Modal
        isOpen={isDashboardModalOpen}
        onRequestClose={closeDashboardModal}
        contentLabel="Task Status"
        className="task-status-modal"
        style={{
          content: {
            width: "625px",
          },
        }}
      >
        <h2>Hello, {openDashboardModalData?.employeeName || "Employee"}</h2>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <ResponsiveContainer width="100%" height={380}>
            <PieChart>
              <Pie
                data={pieData.reduce((acc, curr) => acc + curr.value, 0) === 0 ? [{ value: 1 }] : pieData}
                cx="50%"
                cy="50%"
                labelLine={pieData.reduce((acc, curr) => acc + curr.value, 0) === 0 ? false : { stroke: '#94a3b8', strokeWidth: 1 }}
                innerRadius={82}
                outerRadius={105}
                paddingAngle={4}
                dataKey="value"
                stroke="none"
                label={pieData.reduce((acc, curr) => acc + curr.value, 0) === 0 ? false : ({ cx, cy, midAngle, innerRadius, outerRadius, value, index, name, percent }) => {
                  if (value === 0) return null;
                  const radius = outerRadius + 25;
                  const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
                  const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
                  return (
                    <g>
                      <text x={x} y={y - 8} fill="#ffffff" textAnchor={x > cx ? "start" : "end"} style={{ fontSize: "13px", fontWeight: "600" }}>
                        {`${(percent * 100).toFixed(0)}%`}
                      </text>
                      <text x={x} y={y + 10} fill="#94a3b8" textAnchor={x > cx ? "start" : "end"} style={{ fontSize: "10px", fontWeight: "500", textTransform: 'uppercase' }}>
                        {`${name} (${value})`}
                      </text>
                    </g>
                  );
                }}
              >
                {pieData.reduce((acc, curr) => acc + curr.value, 0) === 0 ? (
                  <Cell fill="rgba(255, 255, 255, 0.05)" />
                ) : (
                  pieData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))
                )}
              </Pie>
              <text x="50%" y="48%" textAnchor="middle" dominantBaseline="middle">
                <tspan x="50%" dy="-10" fill="#94a3b8" style={{ fontSize: '10px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
                  TOTAL TASKS
                </tspan>
                <tspan x="50%" dy="35" fill="#ffffff" style={{ fontSize: '38px', fontWeight: '800' }}>
                  {pieData.reduce((acc, curr) => acc + curr.value, 0)}
                </tspan>
              </text>
              <Tooltip
                contentStyle={{
                  backgroundColor: 'rgba(15, 23, 42, 0.95)',
                  borderColor: 'var(--border)',
                  borderRadius: '10px',
                  backdropFilter: 'blur(10px)',
                  boxShadow: '0 10px 25px rgba(0,0,0,0.5)',
                  border: '1px solid rgba(255,255,255,0.1)'
                }}
                itemStyle={{ color: '#ffffff', fontSize: '14px', fontWeight: '500' }}
                labelStyle={{ color: '#cbd5e1', marginBottom: '4px' }}
              />
              <Legend
                verticalAlign="bottom"
                height={36}
                iconType="circle"
                formatter={(value) => <span style={{ color: '#e2e8f0', fontSize: '13px', fontWeight: '500' }}>{value}</span>}
              />
            </PieChart>
          </ResponsiveContainer>
        )}
      </Modal>


      {/* Address */}
      <Dialog
        open={addressDialogOpen}
        onClose={() => setAddressDialogOpen(false)}
      >
        <DialogContent>
          <Typography variant="h6">Employee Address</Typography>
          <Typography variant="body2">{selectedAddress}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddressDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
      {/* Reset Password Modal */}
      <Modal
        isOpen={isResetPasswordModalOpen}
        onRequestClose={closeResetPasswordModal}
        contentLabel="Reset Password"
        className="reset-password-modal"
      >
        <h2 style={{ fontWeight: "bold" }}>Reset Password</h2>
        {resetPasswordData && (
          <p>
            Reset password for{" "}
            <strong>
              {resetPasswordData.FirstName} {resetPasswordData.LastName}
            </strong>
          </p>
        )}
        {/* New Password Input */}
        <div className="password-container">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Enter new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <span
            className="eye-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
        {/* Confirm Password Input */}
        <div className="password-container">
          <input
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <span
            className="eye-icon"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
        {/* Error Message */}
        {error && <p className="error-message">{error}</p>}
        {/* Action Buttons */}
        <div className="modal-actions">
          <button onClick={handleResetPassword}>Reset Password</button>
          <button onClick={closeResetPasswordModal}>Cancel</button>
        </div>
      </Modal>
      {showDeleteEmployeeBox && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <CiWarning /> Confirm Delete
            </div>
            <div className="popup-message">
              Are you sure you want to remove the employee{" "}
              <span className="employee-name">
                <strong>{deleteEmployeeName}</strong>
              </span>{" "}
              from the system?
            </div>
            <div className="popup-buttons">
              <button
                className="confirm-button"
                onClick={confirmDeleteEmployee}
              >
                Yes, Delete
              </button>
              <button className="cancel-button" onClick={cancelDeleteEmployee}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/*Upload Confirmation Modal for Employees */}
      <Modal
        isOpen={isUploadModalOpen}
        onRequestClose={cancelImageUpload}
        contentLabel="Confirm Upload"
        className="upload-confirmation-modal"
      >
        <h2 style={{ color: "#e74c3c" }}>
          <CiWarning />
          Confirm Upload
        </h2>
        <p>
          Are you sure you want to upload a new profile picture for{" "}
          <strong>{selectedEmployeeName}</strong>?
        </p>
        <div className="form-actions">
          <button onClick={confirmImageUpload} className="confirm-button">
            Yes, Upload
          </button>
          <button onClick={cancelImageUpload} className="cancel-button">
            Cancel
          </button>
        </div>
      </Modal>


      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Employee Form"
        shouldCloseOnOverlayClick={false}
        className="add-employee-modal"
        style={{
          content: {
            width: "625px",
          },
        }}
      >
        <h2>{editMode ? "Edit Employee" : "Add Employee"}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-main">
            <div className="form-row">
              <TextField
                label="First Name"
                name="employee_first_name"
                value={formData.employee_first_name}
                error={!!errors?.employee_first_name || ""}
                helperText={errors?.employee_first_name || ""}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "var(--text-main)" }}>
                      <FaUser />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Middle Name"
                name="employee_middle_name"
                value={formData.employee_middle_name}
                error={!!errors?.employee_middle_name || ""}
                helperText={errors?.employee_middle_name || ""}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "var(--text-main)" }}>
                      <FaUser />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Last Name"
                name="employee_last_name"
                value={formData.employee_last_name}
                error={!!errors?.employee_last_name || ""}
                helperText={errors?.employee_last_name || ""}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "var(--text-main)" }}>
                      <FaUser />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="form-row">
              <TextField
                label="Email"
                name="employee_email"
                value={formData.employee_email}
                error={!!errors?.employee_email || ""}
                helperText={errors?.employee_email || ""}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "var(--text-main)" }}>
                      <MdEmail />
                    </InputAdornment>
                  ),
                }}
              />
              {!editMode && (
                <>
                  <TextField
                    type={showPassword ? "text" : "password"}
                    label="Password"
                    name="employee_password"
                    value={formData.employee_password}
                    error={!!errors?.employee_password || ""}
                    helperText={errors?.employee_password || ""}
                    onChange={handleInputChange}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          style={{ color: "var(--text-main)" }}
                        >
                          <RiLockPasswordFill />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            style={{ color: "var(--text-main)" }}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    type={showConfirmPassword ? "text" : "password"}
                    label="Confirm Password"
                    name="employee_confirm_password"
                    error={!!errors?.employee_confirm_password || ""}
                    helperText={errors?.employee_confirm_password || ""}
                    onChange={handleInputChange}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          style={{ color: "var(--text-main)" }}
                        >
                          <RiLockPasswordFill />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            edge="end"
                            style={{ color: "var(--text-main)" }}
                          >
                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </>
              )}
            </div>
            <div className="form-row" style={{ gap: "8px" }}>
              <div className="gender">
                <FormControl style={{ display: "flex" }}>
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    Gender
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={formData.employee_gender} // Bind value to formData
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        employee_gender: e.target.value,
                      })
                    } // Update formData on change
                  >
                    <FormControlLabel
                      value="male"
                      control={<Radio />}
                      label="M"
                    />
                    <FormControlLabel
                      value="female"
                      control={<Radio />}
                      label="F"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <TextField
                label="Designation"
                name="employee_type"
                value={formData.employee_type}
                error={!!errors?.employee_type || ""}
                helperText={errors?.employee_type || ""}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      style={{ color: "var(--text-main)" }}
                    >
                      <MdBadge />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Contact"
                name="employee_contact"
                value={formData.employee_contact}
                error={!!errors?.employee_contact || ""}
                helperText={errors?.employee_contact || ""}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      style={{ color: "var(--text-main)" }}
                    >
                      <FaMobileRetro />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="form-row">
              <TextField
                select
                label="Department"
                name="employee_dept_id"
                value={formData.employee_dept_id}
                error={!!errors?.employee_dept_id || ""}
                helperText={errors?.employee_dept_id || ""}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "var(--text-main)" }}>
                      <SlOrganization />
                    </InputAdornment>
                  ),
                }}
              >
                {department.map((dept) => (
                  <MenuItem key={dept.DepartmentId} value={dept.DepartmentId}>
                    {dept.DepartmentName}
                  </MenuItem>
                ))}
              </TextField>
              {userRole === "admin" && (
                <TextField
                  select
                  label="Role"
                  name="employee_role"
                  value={formData.employee_role} // Ensure value is bound to state
                  error={!!errors?.employee_role || ""}
                  helperText={errors?.employee_role || ""}
                  onChange={handleInputChange} // Ensure selection updates formData
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "var(--text-main)" }}
                      >
                        <SlOrganization />
                      </InputAdornment>
                    ),
                  }}
                >
                  {/* Admin can assign all roles */}
                  <MenuItem value="M">Manager</MenuItem>
                  <MenuItem value="T">Team Leader</MenuItem>
                  <MenuItem value="E">Employee</MenuItem>
                </TextField>
              )}
              {userRole === "manager" && (
                <TextField
                  select
                  label="Role"
                  name="employee_role"
                  value={formData.employee_role} // Ensure value is bound to state
                  error={!!errors?.employee_role || ""}
                  helperText={errors?.employee_role || ""}
                  onChange={handleInputChange} // Ensure selection updates formData
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "var(--text-main)" }}
                      >
                        <SlOrganization />
                      </InputAdornment>
                    ),
                  }}
                >
                  {/* Admin can assign all roles */}
                  <MenuItem value="T">Team Leader</MenuItem>
                  <MenuItem value="E">Employee</MenuItem>
                </TextField>
              )}
              <TextField
                type="date"
                label="Date Of Join"
                name="employee_dateofjoin"
                value={formData.employee_dateofjoin}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </div>
            <div className="form-row">
              <TextField
                select
                label="City"
                name="employee_city"
                value={formData.employee_city}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "var(--text-main)" }}>
                      <FaTreeCity />
                    </InputAdornment>
                  ),
                }}
              >
                {city.map((cityData) => (
                  <MenuItem key={cityData.CityId} value={cityData.CityId}>
                    {cityData.CityName}
                  </MenuItem>
                ))}
              </TextField>
              {editMode && (
                <TextField
                  type="date"
                  label="Date Of Leave"
                  name="employee_dateofleave"
                  value={formData.employee_dateofleave || ""}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
              )}
            </div>

          </div>
          <div>
            <div className="all-button-form">
              <button type="submit" className="add-button">
                {editMode ? "Save" : "+ Add"}
              </button>
              <button type="button" onClick={closeModal} className="btn-cancel">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default Employee;

